import type { MessageApi, MessageArgsProps } from 'ant-design-vue/lib/message';
import { message } from 'ant-design-vue';

message.config({ top: '68px', duration: 5 });

export function useMessage(type: UseMessageType, conf: MessageArgsProps) {
  message[type]?.(conf);
}

export type UseMessageType = Exclude<
  keyof MessageApi,
  'config' | 'destroy' | 'open' | 'useMessage'
>;
